import { Component, OnInit } from '@angular/core';

import { UserData } from './../../providers/local/user-data';
import { AuthProvider } from '../../providers/auth/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-starter-header',
  templateUrl: './starter-header.component.html',
  styleUrls: ['./starter-header.component.css']
})
export class StarterHeaderComponent implements OnInit {

  constructor(
    public userData:UserData,
    public authWS: AuthProvider,
  	private router: Router
  ) { }

  ngOnInit() {
  }

  logout() {
    this.authWS.logout()
    .then((data: any) => {
      this.router.navigate(['login']);

    });
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/starter/starter-header/starter-header.component.ts